import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, shareReplay, tap } from 'rxjs';

interface CountryApi {
  cca2: string;
  flag: string;
  name: { common: string };
  callingCodes?: string[];
}

interface CountryDial {
  label: string;
  flag: string;
  dial: string;
}
@Injectable({
  providedIn: 'root',
})
export class CountryService {
  private jsonUrl = 'assets/countries/countries.json';
  private countryFlagsCache: Record<string, string> = {};
  private countriesLoaded = false;

  constructor(private http: HttpClient) {}

  getCountries(): Observable<any> {
    return this.http.get<any>(this.jsonUrl).pipe(shareReplay(1));
  }

  getCountryFlag(countryCode: string | undefined): string {
    if (!countryCode) return '';

    if (this.countryFlagsCache[countryCode]) {
      return this.countryFlagsCache[countryCode];
    }

    // If we haven't set up the cache yet
    if (!this.countriesLoaded) {
      // Only subscribe once to avoid memory leaks
      this.getCountries()
        .pipe(
          tap((countries) => {
            this.countriesLoaded = true;
            // Pre-cache all countries
            countries.forEach((c: { cca2: string; flag: string }) => {
              this.countryFlagsCache[c.cca2] = c.flag;
            });
          }),
        )
        .subscribe();
    }

    return this.countryFlagsCache[countryCode] || '';
  }

  getCountryCallingCodes(): Observable<CountryDial[]> {
    return this.getCountries().pipe(
      map((countries: CountryApi[]) =>
        countries.flatMap((c) => {
          if (!c.callingCodes?.length) return [];
          return c.callingCodes.map((dial) => ({
            label: c.name.common,
            flag: c.flag,
            dial,
          }));
        }),
      ),
    );
  }
}
